module.exports = __webpack_public_path__ + "img/sub_support_banner.c493b987.png";